import lscache from 'lscache';

export default {
  path: '/planning',
  meta: {
    pageName: 'Planning',
  },
  component: () => import('./RoutePlanning.vue'),
  children: [
    {
      path: 'overview',
      meta: {
        pageName: 'Overview',
      },
    },
    {
      path: 'workload',
      component: 'planning-workload',
      meta: {
        permission: {
          id: 'canAccessWorkloadPlannerTab',
          redirect: '/planning/chart',
        },
        noSpacing: true,
        name: 'workload',
        pageName: 'Workload',
        isPlanningPage: true, // temporary TKO hack
        canViewFullScreen: true,
        menuPermission: 'canAccessWorkloadPlannerTab',
      },
      beforeEnter(_, to, from, next) {
        lscache.set('twProjects-last-planning-section', 'workload');
        next();
      },
    },
    {
      path: 'portfolio',
      meta: {
        pageName: 'Portfolio',
      },
    },
    {
      path: 'chart',
      meta: {
        pageName: 'Chart',
      },
      component: () => import('./RoutePlanningChart.vue'),
    },
  ],
};
